import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaThLarge,
} from "react-icons/fa";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className="bg-gradient-to-r from-blue-950 to-blue-900 shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto">

          <div className="flex items-center justify-between h-16">

            {/* Categories Button */}
            <div className="hidden lg:flex items-center">
              <button className="bg-yellow-400 text-black font-semibold px-8 h-16 flex items-center gap-3 hover:bg-yellow-500 transition">
                <FaThLarge />
                All Categories
              </button>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center text-white">

              <Link
                className="px-6 py-5 hover:text-yellow-400 transition"
                to="/"
              >
                Home
              </Link>

              <Link
                className="px-6 py-5 hover:text-yellow-400 transition"
                to="/shop"
              >
                Shop
              </Link>

              <Link
                className="px-6 py-5 hover:text-yellow-400 transition"
                to="/Kids "
              >
                Kids zone
              </Link>

              <Link
                className="px-6 py-5 hover:text-yellow-400 transition"
                to="/fashion"
              >
                Fashion
              </Link>

              <Link
                className="px-6 py-5 hover:text-yellow-400 transition"
                to="/groceries"
              >
                Groceries
              </Link>

              <Link
                className="px-6 py-5 hover:text-yellow-400 transition"
                to=""
              >
                Track Order
              </Link>

              <Link
                className="px-6 py-5 hover:text-yellow-400 transition"
                to="/contact"
              >
                Contact Us
              </Link>
            </div>

            {/* Mobile Header */}
            <div className="lg:hidden flex justify-between items-center w-full px-4">

              <button className="bg-yellow-400 text-black px-4 py-2 rounded-lg flex items-center gap-2 font-semibold">
                <FaThLarge />
                Categories
              </button>

              <button
                onClick={() => setMenuOpen(true)}
                className="text-white text-2xl"
              >
                <FaBars />
              </button>

            </div>

          </div>
        </div>
      </nav>

      {/* Mobile Sidebar Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white shadow-2xl z-[999] transform transition-transform duration-300 ${
          menuOpen
            ? "translate-x-0"
            : "translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-5 border-b">

          <h2 className="text-xl font-bold text-blue-950">
            GM Store
          </h2>

          <button
            onClick={() => setMenuOpen(false)}
            className="text-2xl"
          >
            <FaTimes />
          </button>

        </div>

        <div className="flex flex-col">

          <Link
            to="/"
            onClick={closeMenu}
            className="px-6 py-4 border-b hover:bg-gray-100"
          >
            Home
          </Link>

          <Link
            to="/shop"
            onClick={closeMenu}
            className="px-6 py-4 border-b hover:bg-gray-100"
          >
            Shop
          </Link>

          <Link
            to="/Kids "
            onClick={closeMenu}
            className="px-6 py-4 border-b hover:bg-gray-100"
          >
            Kids
          </Link>

          <Link
            to="/fashion"
            onClick={closeMenu}
            className="px-6 py-4 border-b hover:bg-gray-100"
          >
            Fashion
          </Link>

          <Link
            to="/groceries"
            onClick={closeMenu}
            className="px-6 py-4 border-b hover:bg-gray-100"
          >
            Groceries
          </Link>

          <Link
            to="/track-order"
            onClick={closeMenu}
            className="px-6 py-4 border-b hover:bg-gray-100"
          >
            Track Order
          </Link>

          <Link
            to="/contact"
            onClick={closeMenu}
            className="px-6 py-4 border-b hover:bg-gray-100"
          >
            Contact Us
          </Link>

        </div>
      </div>

      {/* Overlay */}
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          className="fixed inset-0 bg-black/50 z-[998]"
        />
      )}
    </>
  );
}